import apiClient from '@/api/client';

// ─── Abstimmungen, Mitteilungen, Vorschläge ──────────────────────────────────
//
// Zwei Richtungen: Abstimmungen und Mitteilungen gehen vom Betreiber zu den
// Kunden, Vorschläge und Fehlermeldungen kommen zurück.

export interface UmfrageOption {
  id: string;
  text: string;
  position: number;
  stimmen: number;
}

export interface Umfrage {
  id: string;
  frage: string;
  text: string | null;
  status: string;
  laeuftBis: string | null;
  planId: string | null;
  nurBesitzer: boolean;
  erstelltVon: string | null;
  createdAt: string;
  optionen: UmfrageOption[];
  teilnehmer: number;
  gesamt: number;
}

export interface UmfrageEingabe {
  frage: string;
  text?: string | null;
  optionen: string[];
  laeuftBis?: string | null;
  planId?: string | null;
  nurBesitzer?: boolean;
}

export async function fetchUmfragen(): Promise<Umfrage[]> {
  const { data } = await apiClient.get<{ data: Umfrage[] }>('/anliegen/umfragen');
  return data.data;
}

export async function createUmfrage(eingabe: UmfrageEingabe): Promise<Umfrage> {
  const { data } = await apiClient.post<Umfrage>('/anliegen/umfragen', eingabe);
  return data;
}

export async function beendeUmfrage(id: string): Promise<void> {
  await apiClient.post(`/anliegen/umfragen/${id}/beenden`);
}

export async function loescheUmfrage(id: string): Promise<void> {
  await apiClient.delete(`/anliegen/umfragen/${id}`);
}

export interface Mitteilung {
  id: string;
  titel: string;
  text: string;
  art: string;
  aktiv: boolean;
  sichtbarBis: string | null;
  planId: string | null;
  nurBesitzer: boolean;
  erstelltVon: string | null;
  createdAt: string;
  bestaetigt: number;
}

export interface MitteilungEingabe {
  titel: string;
  text: string;
  art?: string;
  sichtbarBis?: string | null;
  planId?: string | null;
  nurBesitzer?: boolean;
}

export async function fetchMitteilungen(): Promise<Mitteilung[]> {
  const { data } = await apiClient.get<{ data: Mitteilung[] }>('/anliegen/mitteilungen');
  return data.data;
}

export async function createMitteilung(eingabe: MitteilungEingabe): Promise<Mitteilung> {
  const { data } = await apiClient.post<Mitteilung>('/anliegen/mitteilungen', eingabe);
  return data;
}

export async function ziehMitteilungZurueck(id: string): Promise<void> {
  await apiClient.post(`/anliegen/mitteilungen/${id}/zurueckziehen`);
}

/** Wie viele Konten der gewählte Kreis umfasst – vor dem Absenden. */
export interface EmpfaengerVorschau {
  anzahl: number;
  beispiele: string[];
  abgemeldet: number;
}

export async function empfaenger(kreis: {
  planId?: string | null;
  nurBesitzer?: boolean;
}): Promise<EmpfaengerVorschau> {
  const { data } = await apiClient.post<EmpfaengerVorschau>('/anliegen/empfaenger', kreis);
  return data;
}

export interface Vorschlag {
  id: string;
  art: string;
  titel: string;
  text: string;
  status: string;
  antwort: string | null;
  seite: string | null;
  browser: string | null;
  email: string | null;
  createdAt: string;
}

export async function fetchVorschlaege(filter: {
  art?: string;
  status?: string;
}): Promise<{ data: Vorschlag[]; zaehler: Record<string, number> }> {
  const { data } = await apiClient.get<{ data: Vorschlag[]; zaehler: Record<string, number> }>(
    '/anliegen/vorschlaege',
    { params: filter },
  );
  return data;
}

export async function setzeVorschlagStatus(
  id: string,
  eingabe: { status: string; antwort?: string | null },
): Promise<Vorschlag> {
  const { data } = await apiClient.put<Vorschlag>(`/anliegen/vorschlaege/${id}`, eingabe);
  return data;
}

export async function loescheVorschlag(id: string): Promise<void> {
  await apiClient.delete(`/anliegen/vorschlaege/${id}`);
}
